import NewTheme from '../../NewTheme.json'

export const initialPaletteState = {
  primaryColor: NewTheme.primaryColor,
  secondaryColor: NewTheme.secondaryColor,
  fontFamily: NewTheme.fontFamily,
  buttonStyle: NewTheme.buttonStyle,
  backgroundColor: NewTheme.backgroundColor,
}
